import React, { Component } from 'react'
import { withMediaProps } from 'react-media-player'
import * as colors from '../colors'
import {ButtonCircle} from 'rebass'
import PlayIcon from 'react-icons/lib/md/play-arrow'
import PauseIcon from 'react-icons/lib/md/pause'
import {style} from 'glamor'

class ButtonPlayPause extends Component {
  shouldComponentUpdate({ media }) {
    return this.props.media.isPlaying !== media.isPlaying
  }

  _handlePlayPause = () => {
    this.props.media.playPause()
  }

  render() {
    const { className, media } = this.props

    const Icon =  media.isPlaying
      ? PauseIcon
      : PlayIcon

    return (
      <div
        onClick={this._handlePlayPause}
        {...style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          padding: '1rem',
          alignItems: 'flex-end',
          justifyContent: 'flex-start'
        })}
      >
        <ButtonCircle
          size={40}
          color={colors.nearBlack}
          backgroundColor={colors.yellow}
        >
            <Icon
              style={{display: 'block'}}
              width={'24px'}
              height={'24px'}
              strokeWidth={2}
            />
        </ButtonCircle>
      </div>
    )
  }
}

export default withMediaProps(ButtonPlayPause)



/** WEBPACK FOOTER **
 ** ./src/components/ButtonPlayPause.js
 **/